// Resizable panels (owner, 2026-10-17: "left, right and bottom panel adjustable" on the playground and the canvas).
// A thin wrap of react-resizable-panels: sizes are remembered per `id` in this browser.
import { Panel, PanelGroup, PanelResizeHandle, type PanelProps } from 'react-resizable-panels'
import type { ReactNode } from 'react'

export function Group({ id, direction, children, className = '' }: { id: string; direction: 'horizontal' | 'vertical'; children: ReactNode; className?: string }) {
  return (
    <PanelGroup autoSaveId={`lender-hub-panels:${id}`} direction={direction} className={className}>
      {children}
    </PanelGroup>
  )
}

export function Pane({ children, className = '', ...rest }: PanelProps & { children: ReactNode }) {
  return (
    <Panel {...rest} className={`min-h-0 min-w-0 ${className}`}>
      {children}
    </Panel>
  )
}

/** The drag handle: a thin line that turns teal on hover / while dragging. */
export function Handle({ direction }: { direction: 'horizontal' | 'vertical' }) {
  return (
    <PanelResizeHandle
      className={`group relative shrink-0 bg-slate-200 transition-colors data-[resize-handle-state=drag]:bg-primary data-[resize-handle-state=hover]:bg-primary dark:bg-slate-800 ${direction === 'horizontal' ? 'w-px cursor-col-resize' : 'h-px cursor-row-resize'}`}
      aria-label={direction === 'horizontal' ? 'Resize the panels sideways' : 'Resize the panels up and down'}
    >
      <span className={`absolute ${direction === 'horizontal' ? 'inset-y-0 -left-1 w-2' : 'inset-x-0 -top-1 h-2'}`} />
    </PanelResizeHandle>
  )
}
